import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAgo'
})
export class DateAgoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29) {
        return 'Just now';
      }
      const intervals: { key: string; singular: string; plural: string; seconds: number }[] = [
        { key: 'year', singular: 'year', plural: 'years', seconds: 31536000 },
        { key: 'month', singular: 'month', plural: 'months', seconds: 2592000 },
        { key: 'week', singular: 'week', plural: 'weeks', seconds: 604800 },
        { key: 'day', singular: 'day', plural: 'days', seconds: 86400 },
        { key: 'hour', singular: 'hour', plural: 'hours', seconds: 3600 },
        { key: 'minute', singular: 'minute', plural: 'minutes', seconds: 60 },
        { key: 'second', singular: 'second', plural: 'seconds', seconds: 1 }
      ];
      for (const interval of intervals) {
        const counter = Math.floor(seconds / interval.seconds);
        if (counter > 0) {
          return counter + ' ' + (counter === 1 ? interval.singular : interval.plural) + ' ago';
        }
      }
    }
    return value;
  }

}
